import Vue from 'vue';
// import router from '@/routers';
import _ from 'lodash';
import moment from 'moment';
// 必须引入
import watermark from 'watermark-dom';
import { Message } from 'element-ui';

import UtilCache from './cache';
import UtilDict from './dicts';

const Bus = new Vue();

// 三方投放平台ID
const SPREADER_ID_TOUTIAO = 304;
const SPREADER_ID_GDT = 383;
const SPREADER_ID_FACEBOOK = 21;

const SPREADER_ID_KUAISHOU = 3793;
const SPREADER_ID_ASA = 3965;
const SPREADER_ID_TIKTOK = 4651;
const getSpreaderAlias = (spreaderId) => {
    const spreaderMap = {
        [SPREADER_ID_TOUTIAO]: 'toutiao',
        [SPREADER_ID_GDT]: 'gdt',
        [SPREADER_ID_FACEBOOK]: 'facebook',
        [SPREADER_ID_KUAISHOU]: 'kuaishou',
        [SPREADER_ID_ASA]: 'asa',
        [SPREADER_ID_TIKTOK]: 'tiktok',
    };
    if (Object.keys(spreaderMap).includes(spreaderId.toString())) {
        return spreaderMap[spreaderId];
    }
    return '';
};

const getSpreaderRegionId = (spreaderId) => {
    const spreaderList = UtilCache.getCacheWithChain('baseConfig.spreaders');

    return +_.result(_.find(spreaderList, { spreader_id: +spreaderId }), 'region_id');
};

const getSpreaderText = (spreaderId, isAdjust = false) => {
    let text = '';
    const spreaderTextMap = {
        [SPREADER_ID_TOUTIAO]: '巨量引擎',
        [SPREADER_ID_GDT]: '广点通',
        [SPREADER_ID_FACEBOOK]: 'Facebook',
        [SPREADER_ID_KUAISHOU]: '快手广告',
        [SPREADER_ID_ASA]: 'ASA',
        [SPREADER_ID_TIKTOK]: 'TikTok',
    };
    text = spreaderTextMap[spreaderId] || (isAdjust ? '追踪链接 (adjust 结构)' : '追踪链接');

    return text;
};

// 1.0 方法 即将废弃
const getNewCampaignRouter = (spreaderId) => {
    if (+spreaderId === SPREADER_ID_TOUTIAO) {
        return 'AdvertiseToutiaoCreateCampaign';
    }

    if (+spreaderId === SPREADER_ID_GDT) {
        return 'AdvertiseGdtCreateCampaign';
    }

    return 'AdvertiseTracklinkCreateCampaign';
};

// 图表自定义颜色
const chartColors = ['#F99963', '#60ACFC', '#FFDA43', '#5BC49F', '#FEB54E', '#D4ED58'];
// chartColors: ['#60ACFC', '#65D5B2', '#D4ED58', '#FFDB43', '#FEB54E', '#9DDD81'],

const chartColorsLong = [
    '#60ACFC',
    '#35C5EB',
    '#4DBECF',
    '#65D5B2',
    '#5BC4A0',
    '#9DDD81',
    '#D4ED58',
    '#FFDB43',
    '#FEB54E',
    '#FF9D68',
];
// 交叉颜色-对比鲜明
const chartColorsContrast = ['#60ACFC', '#FF9D68', '#5BC4A0', '#F57582', '#FFDB43', '#8BA2FF', '#BAE637', '#FEB54E', '#4DBECF', '#D4ED58', '#C8A786', '#65D5B2']

const chartExtend = (chartType, tableName) => {
    let extend = {
        yAxis: {
            splitLine: {
                lineStyle: {
                    color: '#e1e2e2',
                    type: 'dashed',
                },
            },
        },
        tooltip: {
            axisPointer: {
                lineStyle: {
                    color: '#e1e2e2',
                    // type: 'dashed',
                    // shadowColor: 'rgba(0, 0, 0, 0.3)',
                    // shadowBlur: 5
                },
            },
        },
    };

    if (chartType === 'line') {
        extend = Object.assign({}, extend, {
            series (v) {
                Array.from(v).forEach((e, idx) => {
                    e.symbol = 'none';
                });
                return v;
            },
        });
    }

    if (chartType === 'histogram') {
        extend = Object.assign({}, extend, {
            series (v) {
                Array.from(v).forEach((e, idx) => {
                    e.barWidth = 30;
                    e.symbol = 'none';
                });
                return v;
            },
            'xAxis.0.axisLabel.rotate': tableName === 'device' ? 45 : 0,
        });
    }

    return extend;
};

// 千分位,自动补齐两位小数
const thousandsFilter = (num, fixed = 2) => {
    if (num === '') {
        return '';
    }

    if (num === null || num === undefined || isNaN(num)) {
        return '-';
    }

    let number = Number.isInteger(+num) ? +num : parseFloat(num).toFixed(fixed);
    return (number + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};

// 千分位,自动补齐两位小数,整数不用特化处理,和旧的方法区分开,开了新的方法
const thousandsFilterFormatter = (num, fixed = 2) => {
    if (Number.isNaN(num)) {
        return '';
    }
    let number = parseFloat(num + '').toFixed(fixed);
    return (number + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};

const formatCornerNumber = (num, digit = 99) => {
    if (num > digit) {
        return `${digit}+`;
    } else {
        return `${num}`;
    }
};

// 获取url中的指定参数
const getQueryString = (name) => {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return '';
};

// 工作表 表格 自定义列宽
const convertColumns = (header, options, screenWidth, fixedRightWidth) => {
    const headerCloned = _.cloneDeep(header);
    let isRemoveWidth = false,
        totalWidth = 0;
    const itemAverageWidth = screenWidth / headerCloned.length;
    // console.log(screenWidth, headerCloned.length, itemAverageWidth);

    if (Object.prototype.toString.call(headerCloned) === '[object Array]') {
        headerCloned.map((item) => {
            if (options) {
                if (Object.keys(options).includes('children')) {
                    options.children.map((cItem) => {
                        setColumnItem(cItem, item);
                    });
                } else {
                    setColumnItem(options, item);
                }
            }

            if ((!item.width || !item.originWidth) && Object.keys(item).includes('children')) {
                // 处理多级表头的 item 宽度
                item.children.forEach((item) => {
                    totalWidth += +item.width || +item.originWidth;
                });
            } else {
                totalWidth += +item.width || +item.originWidth;
            }

            // console.log('totalWidth', totalWidth);
        });

        if (fixedRightWidth && fixedRightWidth > 0) {
            totalWidth += fixedRightWidth;
        }

        if (screenWidth > totalWidth) {
            isRemoveWidth = true;
        }

        // console.log('totalWidth', totalWidth);
        // console.log('screenWidth', screenWidth);
        // console.log('isRemoveWidth', isRemoveWidth);

        headerCloned.map((item) => {
            if (isRemoveWidth) {
                if (item.width < itemAverageWidth) {
                    item.originWidth = item.width;
                    delete item.width;
                }
            } else {
                if (!item.width && item.originWidth) {
                    item.width = item.originWidth;
                }
            }
        });

        return headerCloned;
    }
};

const setColumnItem = (options, item) => {
    const optionItem = options[item.key];
    if (optionItem) {
        for (let key in optionItem) {
            item[key] = optionItem[key];
        }
    }
};

const validAmount = (num, decimalLength = 2) => {
    const regExp = new RegExp(`^[0-9]\\d*(\\.\\d{1,${decimalLength}})?$`);
    return regExp.test(num);
};

const validInt = (num) => {
    const regExp = new RegExp('^-?\\d+$');
    return regExp.test(num);
};

const validateBudget = (value, min, max, fixed) => {
    if (min > value || max < value || isNaN(value)) {
        return false;
    }
    let res = value + '';
    if (fixed) {
        const regExp = new RegExp(`^\\d*(\\.\\d{1,${fixed}})?$`);
        if (!regExp.test(value)) {
            return false;
        }
        res = (+value).toFixed(2);
    }
    return res.startsWith('.') ? `0${res}` : res;
};

const convertTableParams = (filterData) => {
    const params = {
        starttime: filterData.dates[0],
        endtime: filterData.dates[1],
        game_id: filterData.gameId,
        region_id: filterData.regionId,
        store_id: filterData.mallId,
        dimension: filterData.dimension,
        ad_type: filterData.adType,
        spreader_id: filterData.channelId !== undefined ? undefined : filterData.spreaderId,
        natural: filterData.isContainNatural ? 1 : 0,
        channel: filterData.channelId !== undefined ? filterData.channelId : undefined,
    };

    const filterResults = filterData.filter.results;
    if (filterResults.length > 0) {
        const globalType = filterData.filter.globalType;
        const resultObj = {};
        resultObj[globalType] = [];

        filterResults.forEach((item) => {
            // const resultItem = [item.columnId, item.logic, item.isRegionOrLanguage ? item.valueKey : item.valueContent];
            const resultItem = [item.columnId, item.logic, item.valueContent];
            resultObj[globalType].push(resultItem);
        });

        params.search_filter = Object.assign({}, resultObj);
    }

    convertMallId(filterData, params);

    return params;
};

const convertFinanceParams = (filterData) => {
    const params = {
        game_id: filterData.gameId,
        region_id: filterData.regionId,
        store_id: filterData.mallId,
        word: filterData.search,
    };

    if (filterData.month) {
        params.month = filterData.month;
    } else {
        params.start_time = filterData.dateRange[0];
        params.end_time = filterData.dateRange[1];
    }

    convertMallId(filterData, params);

    return params;
};

// params作为输出
const convertMallId = (filterData, params) => {};

const getZeroTimeZone = (time = moment()) => {
    return moment(time).subtract(8, 'h').format('YYYY-MM-DD');
};

const getSimpleDate = (date, serverTime = '') => {
    const timeStamp = moment(date).valueOf();
    const now = serverTime ? moment(serverTime).valueOf() : moment(Date.now()).valueOf();
    const diff = parseInt((now - timeStamp) / 1000);

    if (diff <= 300) {
        return '刚刚';
    }

    if (diff > 300 && diff <= 3600) {
        return `${parseInt(diff / 60)}分钟前`;
    }

    if (diff > 3600 && diff <= 3600 * 24) {
        return `${parseInt(diff / 3600)}小时前`;
    }

    return moment(date).format('YYYY-MM-DD HH:mm');
};

// 用这个方法 不可以判断到有window.opener
const openNewPage = (url, id, options = { isDownload: false }) => {
    var a = document.createElement('a');

    if (!!options.isDownload) {
        a.setAttribute('download', true);
    }

    a.setAttribute('href', url);
    a.setAttribute('target', '_blank');
    a.setAttribute('id', id);

    // 防止反复添加
    if (!document.getElementById(id)) {
        document.body.appendChild(a);
    }

    a.click();
};

// 计算字符长度（中英文）
const getByteLen = (val) => {
    let len = 0;
    for (let i = 0; i < val.length; i++) {
        let a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/gi) != null) {
            len += 2;
        } else {
            len += 1;
        }
    }
    return len;
};

// 截取字符串（中英文）
const sliceByte = (str, start, end) => {
    let len = getByteLen(str);
    if (start >= end) return str;
    let sub = str.slice(getIndex(str, start), getIndex(str, end));
    return sub;

    function getIndex (str, start) {
        let currIndex = 0,
            prev = '',
            sub = '';
        if (start === 0) return 0;
        if (len < start) return str.length;
        while (getByteLen(sub) <= start) {
            currIndex += 1;
            sub = str.slice(0, currIndex);
        }
        return currIndex - 1;
    }
};

const isStrLengthOverflow = (str, len) => {
    return getByteLen(str) <= len;
};

const isStrLengthOverflowMin = (str, len) => {
    return getByteLen(str) >= len;
};

const submitSuccOperation = (msg = '', options = {}, duration = 800) => {
    if (!!msg) {
        Message.success(msg);
    }

    setTimeout(() => {
        if (Object.keys(options).length === 0) {
            window.close();
            return;
        }

        console.log('window.opener', window.opener);
        // TODO Yo
        // 父级页签被关闭时，由当前页刷新至列表页
        // if (!window.opener) {
        //     router.replace({
        //         name: options.routerName,
        //         params: options.params,
        //         query: options.query,
        //     });
        //     return;
        // }

        // 存在父级页签时，刷新父级页面，并关闭当前页
        if (!options.notReload) {
            window.opener.location.reload();
        }
        window.close();
    }, duration);
};

const toStringNumSize = (tempNum) => {
    let stringNum = tempNum.toString();
    let index = stringNum.indexOf('.');
    let newNum = stringNum;
    if (index !== -1) {
        newNum = stringNum.substring(0, index);
    }
    return newNum.length;
};

const unitConversion = (num) => {
    let moneyUnits = ['', '万', '亿', '万亿'];
    let dividend = 10000;
    let curentNum = num;
    if (curentNum / dividend <= 1) {
        return curentNum;
    }
    //转换数字
    let curentUnit = moneyUnits[0];
    //转换单位
    for (let i = 0; i < 4; i++) {
        curentUnit = moneyUnits[i];
        if (toStringNumSize(curentNum) < 5) {
            break;
        }
        curentNum = curentNum / dividend;
    }
    let m = {
        num: 0,
        unit: '',
    };
    m.num = (parseInt(curentNum * 100) / 100).toFixed(1);
    m.unit = curentUnit;
    let countNum = '';
    countNum = `${m.num}${m.unit}`;
    return countNum;
};

const isGameCanUsed = (gameId) => {
    // PG7 game_id: 301
    if (gameId !== 301) {
        return true;
    }

    const userInfo = UtilCache.getLocalItem('userInfo');
    if ([49, 147, 140, 51, 56, 71, 167, 65, 184, 61, 79].includes(userInfo.id)) {
        return true;
    }

    return false;
};

// 是否能够看到观星台
const canSeeObservatory = () => {
    const isShow = UtilCache.getCacheWithChain('userInfo.userAuth.front_auth.observatory.menu.is_show');
    return !!isShow;
};

const findKey = (obj, value, compare = (a, b) => a === b) => {
    return Object.keys(obj).find((k) => compare(obj[k], value));
};

const arrSplit = (str = '', symbolSign = ',') => {
    if (!str) {
        return [];
    }

    const selfString = str.toString();
    if (!selfString) {
        return [];
    }

    if (selfString.indexOf(symbolSign) > -1) {
        return selfString.split(symbolSign);
    }

    return [selfString];
};

const isMobile = () => {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
};

const isIphoneSafari = () => {
    return /Safari/i.test(navigator.userAgent) && /iPhone/i.test(navigator.userAgent);
};

const getDefaultValueInDict = (list, key = 'value') => {
    if (!list || list.length < 1) {
        return undefined;
    }

    const filteredArr = list.filter((v) => v.is_default > 0);
    if (filteredArr.length > 0) {
        return filteredArr[0][key];
    }

    return list[0][key];
};

const isRepeat = (arr) => {
    let hash = {};
    for (let i in arr) {
        if (!!hash[arr[i]]) {
            return true;
        }
        hash[arr[i]] = true;
    }
    return false;
};

const getOptionsFromDict = (allOptions = [], options = []) => {
    return allOptions.filter((i) => {
        return options.includes(i.value);
    });
};

const getLocalGameId = () => {
    let gameId = UtilCache.getCacheWithChain('filter.gameId');

    if (!!gameId) {
        return gameId;
    }

    const gameList = UtilCache.getCacheWithChain('baseConfig.games');
    if (!gameList) {
        return '';
    }
    gameId = gameList.find((v) => v.is_default > 0)?.game_id;
    UtilCache.setCacheWithChain('filter.gameId', gameId);
    return gameId;
};

const getLocalTimezone = () => {
    let timezone = UtilCache.getCacheWithChain('filter.timezone');
    return timezone ?? 0;
};

const saveLocalFilter = (params) => {
    if (params.hasOwnProperty('gameId')) {
        UtilCache.setCacheWithChain('filter.gameId', params.gameId);
    }

    if (params.hasOwnProperty('timezone')) {
        UtilCache.setCacheWithChain('filter.timezone', params.timezone);
    }
};

const saveLocalPageFilter = (url, params, whiteList = ['regionIds', 'uaGroupIds', 'dimension']) => {
    whiteList.forEach((item) => {
        if (params.hasOwnProperty(item)) {
            UtilCache.setCacheWithChain(`${url}.${item}`, params[item]);
        }
    });
};

const auditSensitiveWords = (arr, value) => {
    let wordList = [];
    arr.forEach((item) => {
        if (value.includes(item)) {
            wordList.push(item);
        }
    });

    return wordList;
};

const removeStickyColGroup = (fixedColumnNum, tableClass = '') => {
    const colgroupEle = document.querySelector(`${tableClass} .el-table__fixed-header-wrapper table colgroup`);
    const colEles = document.querySelectorAll(`${tableClass} .el-table__fixed-header-wrapper table colgroup col`);
    if (!!colgroupEle) {
        colEles.forEach((colEle, idx) => {
            if (idx >= fixedColumnNum) {
                colgroupEle.removeChild(colEle);
            }
        });
    }
    const trHeaderEle = document.querySelector(`${tableClass} .el-table__fixed-header-wrapper table thead tr`);
    const thHeaderEles = document.querySelectorAll(`${tableClass} .el-table__fixed-header-wrapper table thead tr th`);
    if (!!trHeaderEle) {
        thHeaderEles.forEach((thHeaderEle, idx) => {
            if (thHeaderEle.classList.contains('is-hidden')) {
                trHeaderEle.removeChild(thHeaderEle);
            }
        });
    }

    const colBodyEles = document.querySelectorAll(`${tableClass} .el-table__fixed-body-wrapper table colgroup`);
    if (!!colBodyEles) {
        colBodyEles.forEach((colBodyEle, idx) => {
            for (let i = colBodyEle.childNodes.length - 1; i >= fixedColumnNum; i--) {
                colBodyEle.removeChild(colBodyEle.childNodes[i]);
            }
        });
    }

    const trBodyEles = document.querySelectorAll(`${tableClass} .el-table__fixed-body-wrapper table tbody tr`);
    if (!!trBodyEles) {
        trBodyEles.forEach((trBodyEle, idx) => {
            for (let i = trBodyEle.childNodes.length - 1; i >= 0; i--) {
                if (trBodyEle.childNodes[i].classList.contains('is-hidden')) {
                    trBodyEle.removeChild(trBodyEle.childNodes[i]);
                }
            }
        });
    }
};

const getDefaultValueBy = (objKey = '', value = 'value') => {
    const arr = UtilCache.getCacheWithChain(objKey);
    if (!arr || Object.prototype.toString.call(arr) !== '[object Array]' || arr.length === 0) {
        console.warn(`${objKey} 不存在，找不到对应的值`);
        return '';
    }

    const filterDefaults = arr.filter((v) => v.is_default > 0);
    if (filterDefaults.length > 0) {
        return filterDefaults[0][value];
    }

    return arr[0][value];
};

const getNameInListBy = (list, value, options = { value: 'value', name: 'name' }) => {
    const filterObj = {};
    filterObj[options.value] = value;
    const obj = _.find(list, filterObj);

    return !!obj ? obj[options.name] : '';
};

const getRandomString = (length) => {
    let str = '',
        arr = [
            'a',
            'b',
            'c',
            'd',
            'e',
            'f',
            'g',
            'h',
            'i',
            'j',
            'k',
            'l',
            'm',
            'n',
            'o',
            'p',
            'q',
            'r',
            's',
            't',
            'u',
            'v',
            'w',
            'x',
            'y',
            'z',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
        ];

    for (let i = 0; i < length; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
    }
    return str;
};

// 高级时间控件输出结果
const weekDay = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];

const getTimeTableText = (timeTable, timeSpan = 48) => {
    if (timeTable.length !== 7) {
        return [];
    }
    // console.log(timeSpan);
    const res = [];
    for (let i = 0; i < 7; i++) {
        let dayList = [];
        let start = -1;
        for (let j = 0; j < timeSpan; j++) {
            if (timeTable[i][j] === 1) {
                if (start === -1) {
                    start = j;
                }
            } else {
                if (start !== -1) {
                    dayList.push(
                        `${getTimeTablePeriodTime(i + 1, start + 1, timeSpan).startTime}~${
                            getTimeTablePeriodTime(i + 1, j, timeSpan).endTime
                        }`
                    );
                }
                start = -1;
            }
        }
        if (start !== -1) {
            dayList.push(
                `${getTimeTablePeriodTime(i + 1, start + 1, timeSpan).startTime}~${
                    getTimeTablePeriodTime(i + 1, timeSpan, timeSpan).endTime
                }`
            );
        }
        if (dayList.length > 0) {
            res.push({ day: weekDay[i], timePeriod: dayList.join('、') });
        }
    }

    return res;
};

// 高级时间控件是否全选
const getTimeTableChooseAllStatus = (list) => {
    if (!list || !list.length) {
        return true;
    }
    let flag = false;
    let timeStrTable = list.toString();
    if (timeStrTable.indexOf('0') === -1 || timeStrTable.replace(/1/g, '').length === 24 * 2 * 7 - 1) {
        flag = true;
    }

    return flag;
};

const getTimeTablePeriodTime = (row, column, timeSpan = 48) => {
    const day = weekDay[row - 1];
    if (timeSpan === 48) {
        const start_hour = ('00' + Math.floor((column - 1) / 2)).slice(-2);
        const start_minute = column % 2 === 0 ? '30' : '00';
        const end_hour = ('00' + Math.floor(column / 2)).slice(-2);
        const end_minute = column % 2 === 0 ? '00' : '30';
        return {
            day,
            startTime: `${start_hour}:${start_minute}`,
            endTime: `${end_hour}:${end_minute}`,
        };
    } else if (timeSpan === 24) {
        const start_hour = ('00' + (column - 1)).slice(-2);
        const end_hour = ('00' + column).slice(-2);
        return {
            day,
            startTime: `${start_hour}:00`,
            endTime: `${end_hour}:00`,
        };
    }
};

const setPageTitle = (route) => {
    let pageTitle = route?.meta?.title;
    if (typeof pageTitle === 'function') {
        pageTitle = pageTitle(route);
    }

    if (!!pageTitle) {
        document.title = `${pageTitle}-DAP`;
    }
};

const isDateBeforeCurrentWeek = (date) => {
    const firstDayOfCurrentWeek = moment().startOf('week');
    return moment(date).isBefore(firstDayOfCurrentWeek);
};

const isDateBeforeOriginWeek = (date, origin) => {
    const originWeek = moment(origin).startOf('week');
    return moment(date).isBefore(moment(originWeek));
};

/** 提取数组元素，返回指定属性名的对象
 *
 *  @param {array} list 数组
 *  @param {string} key 指定的属性名
 *  @return {object} 对象
 */
const getListMap = (list, key = 'id') => {
    const mapObj = {};
    if (list?.length) {
        return list.reduce((obj, item) => {
            obj[item[key]] = item;
            return obj;
        }, mapObj);
    }
    return mapObj;
};

/** 将数组中对象的属性名，转换成目标属性名
 *
 *  @param {array} originList 源数组
 *  @param {object} mapObj 映射关系, 属性名为源数组中对象的属性名，属性值为目标数组中对象的属性名
 *  @param {boolean} isNew  数组元素是使用新的对象还是原对象
 *  @return {array} 目标数组
 */
const convertObjInArray = (originList, mapObj = {}, isNew = true) => {
    if (originList?.length) {
        const mapObjEntries = Object.entries(mapObj);
        if (mapObjEntries?.length) {
            return originList.map((item) => {
                return mapObjEntries.reduce(
                    (obj, [originKey, targetKey]) => {
                        obj[targetKey] = item[originKey];
                        return obj;
                    },
                    isNew ? {} : item
                );
            });
        }
        return originList;
    }
    return [];
};

// 设置浏览器页签名称
const getTitle = (route, preTitle) => {
    return `${preTitle}-${getSpreaderText(route?.params?.spreaderId)}`;
};

const loadDict = async (route) => {
    return new Promise((resolve) => {
        if (route.meta.storage) {
            const storage = typeof route.meta.storage === 'function' ? route.meta.storage(route) : route.meta.storage;
            Promise.all(
                storage.map((item) => {
                    return UtilDict.getDict(item);
                })
            )
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    Message.error('字典加载错误');
                    resolve();
                });
        } else {
            resolve();
        }
    });
};

const formatterMap = {
    F2: (data) => data.toFixed(2),
    // 千分位符一位小数
    TDF1: (data) => thousandsFilterFormatter(data, 1),
    // 千分位符一位小数百分比
    TDF1P: (data) => thousandsFilterFormatter(data, 1) + '%',
    TDF2: (data) => thousandsFilterFormatter(data, 2),
    TDF2P: (data) => thousandsFilterFormatter(data, 2) + '%',
    TDF200P: (data) => thousandsFilterFormatter(data * 100, 2) + '%',
    TDF100P: (data) => thousandsFilterFormatter(data * 100, 1) + '%',
    TDInt: (data) => thousandsFilterFormatter(data, 0),
    F3: (data) => data.toFixed(3),
};

// 含有自定义列的表格的数据format渲染
const formatTableData = (data, format) => {
    // const FORMAT_MAP = {
    //     '两位小数': 'F2',
    //     '千分位符一位小数': 'TDF1',
    //     '千分位符一位小数百分比': 'TDF2P',
    //     '千分位符两位小数': 'TDF2',
    //     '千分位符两位小数百分比': 'TDF2P',
    //     '千分位符两位小数乘以100百分比': 'TDF200P',
    //     '千分位符一位小数乘以100百分比': 'TDF100P',
    //     '千分位符整数': 'TDInt',
    //     '三位小数': 'F3',
    //     '原样展示': 'Identical',
    //     'nan': 'Identical',
    // }
    if (data === undefined || data === null) {
        return '-';
    }
    if (!format || !formatterMap.hasOwnProperty(format)) {
        return data;
    }
    return formatterMap[format](data);
};

/**
 * 从对象中取出prop属性
 * prop可以为.分隔的字符串,例如 'tool.gdt.dict'
 */
const getAttrFromDict = (obj, prop) => {
    if (!obj) {
        return '';
    }
    const splitProp = prop.split('.');
    if (splitProp.length < 2) {
        return obj[prop];
    }
    return getAttrFromDict(obj[splitProp[0]], splitProp.slice(1).join('.'));
};

// 苹果Dislyte专用
const isDislyteUser = () => {
    const userInfo = UtilCache.getLocalItem('userInfo');

    return userInfo.id === 1634;
};

/**
 * 该函数在滚动等频繁触发需要定期执行的时候使用，第一次执行就触发，后续开始定时触发
 * @param {*} fn
 * @param {*} t
 */
let throttleTimer;
export const throttle = (fn, t = 300) => {
    return (...args) => {
        if (throttleTimer) return;
        throttleTimer = window.setTimeout(() => {
            clearTimeout(throttleTimer);
            throttleTimer = null;
        }, t);
        fn.call(this, ...args);
    };
};

const addWatermark = (text) => {
    const defaultText = `${UtilCache.getLocalItem('userInfo').name}   ${moment().format('YYYY年MM月DD日 HH:mm')}`;
    const option = {
        // 水印的内容
        watermark_txt: text || defaultText,
        // 水印字体颜色
        watermark_color: 'black',
        //水印透明度，要求设置在大于等于0.005
        watermark_alpha: 0.08,
        watermark_fontsize: '12px',
        watermark_width: 200,
        watermark_height: 12,
        //水印x轴间隔
        watermark_x_space: 175,
        //水印y轴间隔
        watermark_y_space: 205,
        // 水印倾斜度数
        watermark_angle: 14,
        //水印起始位置x轴坐标
        watermark_x: -10,
        //水印起始位置Y轴坐标
        watermark_y: -20,
    };
    if (window.watermark) {
        window.watermark.load(option);
        return;
    }
    watermark.load(option);
};

const removeWatermark = () => {
    watermark.load({ watermark_txt: ' ' });
};

/**
 * 该函数在类似连续点击按钮最后一次触发，只执行最后一次
 * @param {*} fn
 * @param {*} t
 */
let debounceTimer = null;
export const debounce = (fn, t = 300) => {
    return (...args) => {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => {
            clearTimeout(debounceTimer);
            debounceTimer = null;
            fn.call(this, ...args);
        }, t);
    };
};

/**
 * 用于轮询接口使用
 * @param {*} requestFn 请求函数，需要返回promise，轮询成功返回 1，轮询失败返回 0。
 * e.g
 * requestFn = () => api.post('xxx/preview').then(res => {
 *      if (res.success) {
 *          return 1;
 *      }
 *      if (res.fail) {
 *          return 0;
 *      }
 * });
 * @param {*} t 轮询延时
 * @returns
 */
export const pollRequest = (requestFn, t = 5000) => {
    const pollResult = (cb) => {
        requestFn()
            .then((status) => {
                if ([0, 1].includes(status)) {
                    return cb(status);
                }
                const timer = setTimeout(() => {
                    clearTimeout(timer);
                    return pollResult(cb);
                }, t);
            })
            .catch((err) => cb(0));
    };
    return new Promise((resolve, reject) => {
        pollResult((status) => {
            console.log('status', status);
            return status ? resolve() : reject();
        });
    });
};

/**
 * 将 秒 转换成 时分秒
 * @param {Number} time
 * @param {String} divider
 * @returns String
 */
function formatTime (time, divider = ':') {
    function getTime (time) {
        const addZero = (num) => (num < 10 ? `0${num}` : num);
        const h = addZero(Math.floor(time / 60 / 60)) || '-';
        const m = addZero(Math.floor((time / 60) % 60)) || '-';
        const s = addZero(Math.floor(time % 60)) || '-';
        return h === '00' ? [m, s] : [h, m, s];
    }
    const timeArr = getTime(time);
    return timeArr.join(divider);
}

/**
 * 观星台过滤国家中文名
 * @param {Number} id
 * @returns String
 */
const getDimCountry = (id) => {
    let countrys = UtilCache.getCacheWithChain('observatoryDict.country');
    let country = countrys?.find((item) => item.id === id);
    return country ? country.name : '';
};

/**
 * 观星台财务数据可见权限控制
 * @returns Boolean
 */
const canSeeFinancePage = () => {
    const names = [
      '周宇梁', '王力扬', '杨强', '柳超', '王珺', '奚晓丽', '朱清华', '庄祯俊', '全粤莉', '徐凯晴', '薛丰', '张天照', '周润来', '陈康康',
      '王信文', '张昊', '袁帅', '杨韵雅', '张子龙', '田晓东', '胡睿', '于丹萍', '张少晨', '胡露', '李双', '尧亚兰', '兆佳', '郁菲', '王昭智', '肖烨华', '包坤灵', '黄煜琴', '杨雁娇', '董颖', '吴婷红', '祝艳丽',
    ];

    const userInfo = UtilCache.getLocalItem('userInfo') || {};

    return names.filter(i => userInfo.name.includes(i)).length > 0;
};

/**
 * 落地页-排除以下用户创建的数据
 * 周宇梁（873）王力扬（1962）
 * 徐凯晴（544）朱清华（1749）
 * 胡强强（1958）董馨蕊（1991）余大云（2055）王乾坤（2056）张成龙（2106）杨志浩（2015）
 */
export const getExcludesUserIds = () => {
  const excludesUserIds = [873, 1962, 544, 1749, 1958, 1991, 2055, 2056, 2106, 2015];
  const userInfo = UtilCache.getLocalItem('userInfo') || {};
  return excludesUserIds.includes(userInfo.id) ? '' : excludesUserIds.join();
};

/**
 * 所有页面-数据维度列表
 * gameId: 游戏ID
 * filter: 是否对游戏列表过滤，默认过滤
 * */
const getDimensionList = (gameId = '', filter = true) => {
    const list = [
        { value: 'apg', name: '账号' },
        { value: 'account', name: '单包账号' },
        { value: 'device', name: '设备' },
    ];
    if(!filter || +gameId === 10078){
        return list;
    }
    return list.filter(i => {
        return i.value !== 'account';
    });
};
const getOnlySingleDimensionList = (gameId = '', filter = true) => {
    const list = [
        { value: 'apg', name: '账号' },
        { value: 'account', name: '单包账号' },
    ];
    if(!filter || +gameId === 10078){
        return list;
    }
    return list.filter(i => {
        return i.value !== 'account';
    });
};
export default {
    Bus,
    isGameCanUsed,
    canSeeObservatory,
    getNewCampaignRouter,
    getOnlySingleDimensionList,
    getSpreaderAlias,
    getSpreaderRegionId,
    SPREADER_ID_TOUTIAO,
    SPREADER_ID_GDT,
    SPREADER_ID_FACEBOOK,
    SPREADER_ID_KUAISHOU,
    SPREADER_ID_ASA,
    SPREADER_ID_TIKTOK,
    chartColors,
    chartColorsLong,
    chartColorsContrast,
    chartExtend,
    thousandsFilter,
    thousandsFilterFormatter,
    getQueryString,
    convertColumns,
    validAmount,
    validInt,
    validateBudget,
    convertTableParams,
    convertFinanceParams,
    convertMallId,
    getZeroTimeZone,
    openNewPage,
    isStrLengthOverflow,
    isStrLengthOverflowMin,
    submitSuccOperation,
    unitConversion,
    getByteLen,
    sliceByte,
    findKey,
    arrSplit,
    isMobile,
    isIphoneSafari,
    // 待优化，向 getDefaultValueBy 靠齐
    getDefaultValueInDict,
    isRepeat,
    getLocalGameId,
    getLocalTimezone,
    saveLocalFilter,
    saveLocalPageFilter,
    getOptionsFromDict,
    auditSensitiveWords,
    getDefaultValueBy,
    getNameInListBy,
    removeStickyColGroup,
    getRandomString,
    getSimpleDate,
    getTimeTableText,
    getTimeTableChooseAllStatus,
    getTimeTablePeriodTime,
    getSpreaderText,
    setPageTitle,
    isDateBeforeCurrentWeek,
    getListMap,
    convertObjInArray,
    getTitle,
    formatTableData,
    loadDict,
    isDateBeforeOriginWeek,
    getAttrFromDict,
    isDislyteUser,
    throttle,
    debounce,
    formatTime,
    formatCornerNumber,
    getDimCountry,
    pollRequest,
    addWatermark,
    removeWatermark,
    getDimCountry,
    canSeeFinancePage,
    getExcludesUserIds,
    getDimensionList
};
